import React from 'react';
import { ContactDepartmentEditTemplate } from 'themes/application/contact-department/pages';
import { observer } from 'mobx-react';
import { ContactDepartmentEditViewStore } from 'application/contact-department/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ContactDepartmentEditViewStore(rootStore), 'contactDepartmentEditViewStore')
@observer
class ContactDepartmentEdit extends React.Component {
    render() {
        return <ContactDepartmentEditTemplate {...this.props} />
    }
}

export default ContactDepartmentEdit;
